import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import useTestStore from '../../stores/testStore';
import moment from 'moment';
import { Grid, Typography } from '@mui/material';

const FormContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  '& .MuiTextField-root': {
    margin: theme.spacing(1, 0.5),
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  margin: theme.spacing(2, 0),
  fontWeight: 500,
  color: theme.palette.text.secondary,
}));

const DescriptionField = styled(TextField)(({ theme }) => ({
  width: '500px',
  marginTop: theme.spacing(2),
}));

export default function TestEssentialDetails() {
  const testDoc = useTestStore(state => state.testDoc);
  const setTestDoc = useTestStore(state => state.setTestDoc);

  const handleCheckboxChange = (event) => {
    setTestDoc({
      ...testDoc,
      active: event.target.checked
    });
  };

  const handleChange = (event) => {
    setTestDoc({
      ...testDoc,
      [event.target.id]: event.target.value
    });
  };

  return (
    <Box>
      <SectionTitle variant="subtitle1">Test Core Details</SectionTitle>

      <FormContainer component="form">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6} md={5}>
            <TextField
              id="testTitle"
              label="Title of Test"
              value={testDoc.testTitle ?? ''}
              onChange={handleChange}
              variant="outlined"
              fullWidth
            />
          </Grid>

          <Grid item xs={3} md={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={testDoc.active ?? true}
                  onChange={handleCheckboxChange}
                  color="primary"
                />
              }
              label="Active"
            />
          </Grid>

          <Grid item xs={12} md={5}>
            <TextField
              id="postTime"
              label="Time of Test"
              value={testDoc.postTime ? moment.unix(testDoc.postTime.seconds).calendar() : ''}
              variant="filled"
              InputProps={{ readOnly: true }}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              id="park"
              label="Park"
              value={testDoc.park ?? ''}
              onChange={handleChange}
              variant="outlined"
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              id="tingedBy"
              label="Tinged by"
              value={testDoc.tingedBy ?? ''}
              onChange={handleChange}
              variant="outlined"
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <DescriptionField
              id="metaDescription"
              label="Description"
              value={testDoc.metaDescription ?? ''}
              rows={6}
              multiline
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>
        </Grid>
      </FormContainer>
    </Box>
  );
}
